import { useQuery } from "react-query";
import { Raster } from "guppy.ts";
import { guppy } from "../services/guppy.service";

export function useRaster(uuid: string) {
  return useQuery<Raster>(["raster", uuid], () => guppy.getRaster(uuid));
}
